var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-cart__controls"},[_c('a',{attrs:{"href":"/cart"}},[_vm._v("\n    View Cart\n  ")]),_c('a',{attrs:{"href":"/checkout"}},[_vm._v("\n    Check Out\n  ")])])
}]

export { render, staticRenderFns }